<template>
  <div id="wt-form-right">
    <div id="wt-loading" :class="{'wt-loading-show': showLoading}">
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>

    <div id="wt-form-right-header">
      <!-- Slot Toolbar -->
      <slot name="toolbars"></slot>
    </div>

    <div id="wt-form-right-main">
      <alert v-model="showAlert" :message="message" :variant="variant"></alert>
      <slot name="table"></slot>
      <slot name="form"></slot>
    </div>

    <!-- Footer
        <div id="wt-form-right-footer"></div> 
    -->
  </div>
</template>
<script>
import alert from "@/components/widgets/Alert.vue";
export default {
  components: { alert },
  computed: {
    showLoading() {
      return this.$store.state.loading.showLoading;
    },
    /*showLoading() {
      return this.$store.getters["showLoading"];
    },*/
    showAlert() {
      return this.$store.getters["alert/showAlert"];
    },
    message() {
      return this.$store.getters["alert/message"];
    },
    variant() {
      return this.$store.getters["alert/variant"];
    }
  }
};
</script>
